import { useMemo } from 'react';
import { Model } from '../services';
import { Spinner } from '../../../components/UI-CHAKRA/Spinner';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { useLoading } from '../../../helpers/useLoading';
import { Box } from '../../../components/UI-CHAKRA/Box';
import { ReactComponent as FileIcon } from '../../../assets/images/icons/mevo/model.svg';
import { ReactComponent as MultipleFileIcon } from '../../../assets/images/icons/mevo/institutional-model.svg';
import { ReactComponent as InstitutionIcon } from '../../../assets/images/icons/mevo/institution.svg';
import { ReactComponent as StarIcon } from '../../../assets/images/icons/mevo/star.svg';

interface PrescriptionModelItemProps {
  model: Model;
  onSelectModel: (model: Model) => Promise<void>;
}

export function PrescriptionModelItem(props: PrescriptionModelItemProps) {
  const [loadingModel, runWithLoadingModel] = useLoading();

  const { model } = props;

  const selectModel = () => {
    runWithLoadingModel(async () => {
      await props.onSelectModel(model);
    });
  };

  const ModelIcon = useMemo(() => {
    if (loadingModel) {
      return (
        <Flex alignItems={'center'} m={0}>
          <Spinner color={'info.main'} thickness="2px" w={'22px'} h={'22px'} />
        </Flex>
      );
    }
    return (
      <Box fill={'primary.main'} m={0} p={0}>
        {props.model.institucional ? <MultipleFileIcon height={'27px'} /> : <FileIcon height={'27px'} />}
      </Box>
    );
  }, [loadingModel, props.model.institucional]);

  return (
    <Flex
      borderRadius={'8px'}
      border={model.destacado ? 'none' : '1px solid rgba(0,0,0,0.08)'}
      p={'8px 10px'}
      m={'10px 0px'}
      justifyContent={'space-between'}
      alignItems={'center'}
      cursor={'pointer'}
      w={'160px'}
      bg={model.destacado ? '#FFE4EB' : 'white'}
    >
      <Flex justifyContent={'flex-start'} alignItems={'center'} onClick={selectModel}>
        <Flex mr={'10px'} w={'25px'}>
          {ModelIcon}
        </Flex>
        <Box w={'100px'} data-cy={model.nome}>
          {props.model.destacado && (
            <Flex
              gap={'4px'}
              mb={'2px'}
              p={'2px 5px'}
              bg={'#F8A8BD'}
              w={'fit-content'}
              borderRadius={'5px'}
              data-testid={'highlighted-model'}
            >
              <StarIcon stroke={'white'} />
              <Text color={'white'} fontWeight={400} fontSize={'10px'} lineHeight={'11px'}>
                Destaque
              </Text>
            </Flex>
          )}

          {props.model.institucional && (
            <Flex gap={'4px'} mb={'2px'} data-testid={'institutional-model'}>
              <InstitutionIcon />
              <Text color={'#868E96'} fontWeight={400} fontSize={'10px'} lineHeight={'11px'}>
                Institucional
              </Text>
            </Flex>
          )}

          <Text
            userSelect={'none'}
            fontSize={'14px'}
            textOverflow={{ base: 'none', md: 'ellipsis' }}
            whiteSpace={{ base: 'pre-wrap', md: 'nowrap' }}
            overflow={'hidden'}
            lineHeight={'16px'}
          >
            {model.nome}
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
}
